import { useCallback, useRef } from 'react';
import { useEventListener } from './use-event-listener';
/**
 * Binds a click event listener to the given container to allow click events to be be optionally prevented from being handled by the browser.
 */
export function usePreventNextClick(targetRef) {
    const preventClick = useRef(false);
    const handleClick = useCallback((event) => {
        if (preventClick.current) {
            event.stopPropagation();
            preventClick.current = false;
        }
    }, []);
    useEventListener(targetRef, 'click', handleClick, { capture: true });
    return {
        preventNextClick: () => (preventClick.current = true)
    };
}
//# sourceMappingURL=use-prevent-next-click.js.map